(() => {
  const body = document.body;
  let isLoaded = false;
  let isLoading = false;

  function getMount() {
    return document.querySelector('[data-mobile-filter-mount]');
  }

  function getDrawer() {
    return document.getElementById('MobileFilterDrawer');
  }

  function getTrigger() {
    return document.querySelector('[data-mobile-filter-open]');
  }

  function sectionUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', 'mobile-facets-drawer');
    return url.toString();
  }

  function openDrawer() {
    const drawer = getDrawer();
    const trigger = getTrigger();

    if (!drawer) return;

    drawer.removeAttribute('hidden');
    drawer.classList.add('is-open');
    body.classList.add('mobile-filter-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    const firstFocusable = drawer.querySelector('[data-mobile-filter-close], select, input, button, a');
    if (firstFocusable) {
      firstFocusable.focus({ preventScroll: true });
    }
  }

  function closeDrawer() {
    const drawer = getDrawer();
    const trigger = getTrigger();

    if (!drawer) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('hidden', '');
    body.classList.remove('mobile-filter-open');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({ preventScroll: true });
    }
  }

  async function loadDrawer() {
    const mount = getMount();

    if (!mount || isLoaded || isLoading) return;

    isLoading = true;

    try {
      const response = await fetch(sectionUrl(), {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Mobile facets request failed: ${response.status}`);
      }

      const html = await response.text();
      const temp = document.createElement('div');
      temp.innerHTML = html.trim();

      const drawer = temp.querySelector('#MobileFilterDrawer');

      if (!drawer) {
        throw new Error('MobileFilterDrawer was not found in fetched section HTML.');
      }

      /**
       * Critical:
       * Do NOT mount the drawer inside the collection grid.
       * Put it directly under body so position: fixed uses the viewport.
       */
      body.appendChild(drawer);

      /**
       * Keep the mount empty.
       * This preserves clean initial HTML and prevents layout containment issues.
       */
      mount.innerHTML = '';

      isLoaded = true;
    } catch (error) {
      console.error(error);
    } finally {
      isLoading = false;
    }
  }

  document.addEventListener('click', async (event) => {
    const openButton = event.target.closest('[data-mobile-filter-open]');

    if (openButton) {
      event.preventDefault();

      await loadDrawer();
      openDrawer();

      return;
    }

    const closeButton = event.target.closest('[data-mobile-filter-close]');

    if (closeButton) {
      event.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });
})();